import axios from 'axios';

export const getUnsafeImageUrls = (error: unknown): string[] => {
  if (!axios.isAxiosError(error) || error.response?.status !== 400) return [];

  const data = error.response.data;
  if (!data || typeof data !== 'object' || !Array.isArray(data.unsafeImageUrls)) return [];

  return data.unsafeImageUrls.filter((url: unknown): url is string => typeof url === 'string');
};
